import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  let refreshing = false

  // ¿Había ya un SW controlando al cargar? Si NO, es la PRIMERA instalación y no
  // debemos recargar (clientsClaim dispara controllerchange también ahí).
  const hadController = !!(navigator.serviceWorker && navigator.serviceWorker.controller)

  // Seguridad: NO recargar con un parte ABIERTO (formulario sin guardar) -> se
  // perdería lo que el conductor está escribiendo. Los partes YA guardados viven
  // en IndexedDB (vuex-persist persiste todo el estado) y sobreviven a la recarga.
  const parteAbierto = () => !!document.querySelector('form button[type="submit"]')

  const recargar = () => {
    if (refreshing) return
    refreshing = true
    window.location.reload()
  }

  // Aplica la versión nueva en cuanto sea seguro: si hay un parte abierto,
  // espera a que el conductor lo cierre/guarde y entonces recarga.
  const aplicarCuandoSeguro = () => {
    if (refreshing) return
    if (!parteAbierto()) return recargar()
    const iv = setInterval(() => {
      if (!parteAbierto()) { clearInterval(iv); recargar() }
    }, 1500)
  }

  // El SW nuevo (skipWaiting + clientsClaim) toma el control -> 'controllerchange'.
  // Solo recargamos si YA había un SW antes (actualización, no primera instalación).
  if (navigator.serviceWorker) {
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (hadController) aplicarCuandoSeguro()
    })
  }

  // Red de seguridad: si una pestaña vieja pide un chunk que el SW nuevo ya
  // purgó (ChunkLoadError), saltamos a la versión nueva en cuanto sea seguro.
  const esErrorDeChunk = (m) => /ChunkLoadError|Loading chunk|Loading CSS chunk/i.test(m || '')
  window.addEventListener('error', (e) => {
    if (esErrorDeChunk(e && e.message)) aplicarCuandoSeguro()
  })
  window.addEventListener('unhandledrejection', (e) => {
    const r = e && e.reason
    if (esErrorDeChunk(r && (r.message || String(r)))) aplicarCuandoSeguro()
  })

  register(`${process.env.BASE_URL}service-worker.js`, {
    registered () {
      console.log('Service worker registrado.')
    },
    updatefound () {
      console.log('Descargando versión nueva…')
    },
    updated () {
      // La recarga la dispara 'controllerchange' (skipWaiting + clientsClaim).
      console.log('Versión nueva disponible.')
    },
    offline () {
      console.log('Sin conexión: la app funciona en modo offline.')
    },
    error (error) {
      console.error('Error en el service worker:', error)
    }
  })
}
